// Product Types
export const PRODUCT_TYPE_MEGAPORT = 'MEGAPORT'
export const PRODUCT_TYPE_MCR2 = 'MCR2'
export const PRODUCT_TYPE_MVE = 'MVE'
export const PRODUCT_TYPE_VXC = 'VXC'
export const PRODUCT_TYPE_IX = 'IX'
export const PRODUCT_TYPE_LAG = 'LAG'

// Quote Statuses
export const QUOTE_STATUS_REGISTERED = 'REGISTERED'
export const QUOTE_STATUS_SAVED = 'SAVED'

export const LOGIN_COGNITO = 'cognito'
export const LOGIN_GOOGLE = 'google'

export const X_APP = 'quoting_tool'

export const API_GATEWAY_CLIENT = Symbol('apiGateway')
export const CPQ_LITE_CLIENT = Symbol('cpqLite')

// Megaport staff get some additional features
export const MEGAPORT_ID = 1
export const MEGAPORT_LAB_ID = 1153

export const ACCOUNT_TYPE_ADMIN = 'ADMIN'
export const ACCOUNT_TYPE_DIRECT_CUSTOMER = 'DIRECT_CUSTOMER'
export const ACCOUNT_TYPE_MANAGED_ACCOUNT = 'MANAGED_ACCOUNT'
export const ACCOUNT_TYPE_PARTNER = 'PARTNER'

export const ACCOUNT_TYPE_DISCOUNT_REASONS = Object.freeze({
  WHOLESALE: 'WHOLESALE',
  PARTNER: 'PARTNER',
  PARTNER_MANAGED: 'PARTNER_MANAGED',
})

export const DISCOUNT_REASONS = Object.freeze({
  ...ACCOUNT_TYPE_DISCOUNT_REASONS,
  TERM: 'TERM',
})

export const TARGET_TYPES = Object.freeze({
  EXISTING_COMPANY: 'EXISTING',
  NEW_COMPANY: 'NEW',
  SELF: 'SELF',
})

// We need this so we can still show a default list of terms before we call the API and find out the actual list
export const DEFAULT_TERM_PRICES = Object.freeze({
  1: null,
  12: null,
  24: null,
  36: null,
})

// Add-on types
export const ADDON_TYPES = Object.freeze({
  CROSS_CONNECT: 'CROSS_CONNECT',
})

// Add-on pricing frequency
export const ADDON_PRICE_FREQUENCY = Object.freeze({
  MONTHLY: 'MONTHLY',
  ONCE: 'ONCE',
})

export const FRANCEIX_UID = 'ce291fed-90b2-46df-8b39-f87342bd0de7'

// The first of the companyUids will be the one that is used in the target select listing,
// and will be matched with the appropriate icon.
// TODO: Update this to be on par with portal's version
export const CLOUD_ITEMS = [
  {
    connectType: 'OUTSCALE',
    title: '3DS OUTSCALE',
    companyUids: ['1bfc203b-b9a3-46c1-85a3-e4eab6abf439'],
  },
  {
    connectType: 'ALIBABA',
    title: 'Alibaba Cloud',
    companyUids: ['182ef3f4-5b74-4adf-9710-6f37a01be434'],
  },
  {
    connectType: ['AWS', 'AWSHC'],
    title: 'Amazon Web Services',
    companyUids: ['605cb850-dfb4-4a05-a171-8bf17757b3a2'],
  },
  {
    connectType: 'AMSIX',
    title: 'AMS-IX',
    companyUids: ['cd92fac4-7f75-4fb0-bd24-19dcb9ed3e8e'],
  },
  {
    connectType: 'GOOGLE',
    title: 'Google Cloud',
    companyUids: ['29ba879b-45c8-48eb-bd97-618d0f20ea04'],
  },
  {
    connectType: 'IBM',
    title: 'IBM Cloud',
    companyUids: ['dfaa7d3f-450b-4a1e-9026-27cb02c5098d'],
  },
  {
    connectType: 'AZURE',
    title: 'Microsoft Azure',
    companyUids: ['c40de5ed-4707-4471-a78c-69436de2c505'],
  },
  {
    connectType: 'ORACLE',
    title: 'Oracle Cloud',
    companyUids: ['8ea83603-445c-40c6-94cf-67967a18beb9'],
  },
  {
    connectType: 'NUTANIX',
    title: 'Nutanix',
    companyUids: ['0dda2b1b-6129-4916-adbe-417cefdcaef4', '7752dde1-1cd2-4633-adad-f132a733ff78'],
  },
  {
    connectType: 'SFDC',
    title: 'Salesforce',
    companyUids: ['98ab066a-b945-4369-ad72-ee5a8dc35fbc'],
  },
  {
    connectType: 'SAP',
    title: 'SAP',
    companyUids: ['7769fd21-9ac5-41ed-aed4-bb4615f1cbe0'],
  },
  {
    connectType: 'IX',
    title: 'Internet Exchange',
    megaIcon: 'IX',
    companyUids: [],
  },
]
